var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendingNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7951 3.13574H15.1172C15.434 3.13574 15.6951 3.36995 15.7308 3.67169L15.7349 3.74244V7.98936C15.7349 8.32444 15.4584 8.59607 15.1172 8.59607C14.8004 8.59607 14.5393 8.36185 14.5036 8.06012L14.4995 7.98936L14.499 5.20702L9.99439 9.63177C9.77184 9.85034 9.4217 9.8673 9.17936 9.68254L9.12116 9.63214L7.70284 8.24157L4.4362 11.4509C4.195 11.6879 3.80387 11.6879 3.56259 11.451C3.33987 11.2324 3.32269 10.8882 3.51107 10.6502L3.56245 10.593L7.26551 6.95493C7.48805 6.7363 7.83823 6.71931 8.0806 6.90409L8.13881 6.95449L9.5572 8.34513L13.6249 4.34915H10.7951C10.4783 4.34915 10.2172 4.11494 10.1815 3.8132L10.1773 3.74244C10.1773 3.43131 10.4158 3.17487 10.723 3.13982L10.7951 3.13574H15.1172H10.7951Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingNow);
export default __webpack_public_path__ + "static/media/trending-now.0e4b1e2f.svg";
export { ForwardRef as ReactComponent };